import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import React, { createContext, useEffect, useState, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultGetLocationId = function defaultGetLocationId(track) {
  return track.join(',');
};
var defaultGetLocationPathname = function defaultGetLocationPathname(location) {
  if (typeof location === 'string') {
    return location;
  } else {
    return location.pathname;
  }
};
export var BackLinkContext = /*#__PURE__*/createContext({
  historyStack: [],
  getLocationPathname: defaultGetLocationPathname
});
function BackLinkProvider(_ref) {
  var children = _ref.children,
    location = _ref.location,
    track = _ref.track,
    _ref$getLocationId = _ref.getLocationId,
    getLocationId = _ref$getLocationId === void 0 ? defaultGetLocationId : _ref$getLocationId,
    _ref$getLocationPathn = _ref.getLocationPathname,
    getLocationPathname = _ref$getLocationPathn === void 0 ? defaultGetLocationPathname : _ref$getLocationPathn,
    wasRedirected = _ref.wasRedirected;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    historyStack = _useState2[0],
    setHistoryStack = _useState2[1];
  var haveTrackedDependenciesChanged = useRef(false);

  // We track dependencies in this separate effect because
  // the main effect needs to run every time the location changes.
  // This allows us to only create _new_ history entries when
  // a tracked dependency changes, but to also keep the current
  // location entry up to date with all changes, tracked or not.
  useEffect(function () {
    haveTrackedDependenciesChanged.current = true;
  }, track); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    var wrappedLocation = {
      location: location,
      id: getLocationId(track)
    };
    setHistoryStack(function (prevHistory) {
      var locationIndex = prevHistory.findIndex(function (entry) {
        return entry.id === wrappedLocation.id;
      });
      var newHistory = _toConsumableArray(prevHistory);
      if (locationIndex === -1) {
        // If this is a new location, add it as a new entry
        newHistory = [].concat(_toConsumableArray(newHistory), [wrappedLocation]);
        locationIndex = newHistory.length - 1;
      } else {
        // If the tracked dependencies haven't changed, we only
        // update the current location with its latest state, so
        // that going back always restores the last viewed URL state
        if (!haveTrackedDependenciesChanged.current) {
          newHistory[locationIndex] = wrappedLocation;
          return newHistory;
        }

        // The location already exists in the history stack,
        // so we discard any entries after it
        newHistory = newHistory.slice(0, locationIndex + 1);
      }
      var previousIndex = newHistory.length - 2;

      // If we were redirected to this location, discard
      // the previous entry so we can skip the redirect
      if (wasRedirected && previousIndex <= 0 && newHistory[previousIndex]) {
        newHistory.splice(previousIndex, 1);
      }
      return newHistory;
    });
    return function () {
      haveTrackedDependenciesChanged.current = false;
    };
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(BackLinkContext.Provider, {
    value: {
      historyStack: historyStack,
      getLocationPathname: getLocationPathname
    },
    children: children
  });
}
export default BackLinkProvider;